import api from '@synergycms_core/utils/api';
import loggerGetter from '@synergycms_core/utils/logger';
import EPG_BASE from './epgBase';

export default class EPG extends EPG_BASE {

  /**
   *
   * @param environment {string}
   * @param reservation {Map}
   * @param hotel {Map}
   * @param tpvPaymentStatus {string}
   * @param setReservationPayed {function}
   * @param showConfirmation {function}
   * @param showErrorNotification {function}
   */
  constructor(
    environment,
    reservation,
    hotel,
    tpvPaymentStatus,
    setReservationPayed,
    showConfirmation,
    showErrorNotification
  ) {
    super(environment);

    if (
      tpvPaymentStatus === 'EPG:OK' &&
      reservation.get('status') === 'confirmed' &&
      reservation.getIn(['payment', 'payform_code']) === 'op'
    ) {
      setReservationPayed(reservation, hotel.get('show_taxes'));
      showConfirmation(reservation, hotel);
    } else if (tpvPaymentStatus === 'EPG:ERROR') {
      showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
    }
  }

  /**
   *
   * @param hotel {Map}
   * @param reservation {Map}
   * @param countryCode {string}
   * @param langCode  {string}
   * @param formId {string}
   * @param showErrorNotification {function}
   * @param setStateEPGPrepaymentToken {function}
   * @param checkTpvContainer {function}
   */
  initialize = (
    hotel,
    reservation,
    countryCode,
    langCode,
    formId,
    showErrorNotification,
    setStateEPGPrepaymentToken,
    checkTpvContainer
  ) => {
    this.loadingTpvAuth = false;
    this.prepayToken = false;
    this.validPAN = false;
    this.authRetries++;
    setStateEPGPrepaymentToken(false);
    if (
      reservation.get('status') === 'confirmed' &&
      reservation.getIn(['payment', 'payform_code']) === 'op' &&
      reservation.getIn(['payment', 'state']) === 'pending'
    ) {
      showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
    }
    this.loadingTpvAuth = this.sendAuthRequest(
      hotel.get('code'),
      hotel.get('id'),
      reservation.get('tracking_id'),
      countryCode,
      hotel.getIn(['currency', 'code'])
    )
      .catch(error => {
        if (this.authRetries <= 10) {
          setTimeout(() => {
            this.initialize(
              hotel,
              reservation,
              countryCode,
              langCode,
              formId,
              showErrorNotification,
              setStateEPGPrepaymentToken,
              checkTpvContainer
            );
          }, 2000);
        }
        if (!this.emailSent) {
          let errorMessage = error.stack !== undefined ? error.stack : error.code.stack;

          if (errorMessage && errorMessage.indexOf('Failed to fetch') !== -1) {
            const domain =
              process.env.NODE_ENV === 'development'
                ? 'https://www.eurostarshotels.com'
                : document.location.protocol + '//' + document.location.host;
            const url = domain + '/tpv/EPG/authToken.php';
            const data = {
              hotel: hotel.get('code'),
              tracking_id: reservation.get('tracking_id'),
              country: countryCode,
              currency: hotel.getIn(['currency', 'code'])
            };
            errorMessage += ': ' + url + ' ' + JSON.stringify(data);
          }

          api.post(
            'cms/send_avail_error',
            [{ url: window.document.location.href, message: 'Error tpvAuth EPG', error: errorMessage }],
            hotel.get('id')
          );
          this.emailSent = true;
        }
        throw error;
      })
      .tap(response => {
        checkTpvContainer();
        if (this.firstLoad) {
          this.scriptTagPromise.then(() => {
            if (this.firstLoad) {
              this.firstLoad = false;
              this.renderCashier(response.authToken, this.successEvent, langCode, formId);
            }
          });
        } else {
          this.renderCashier(response.authToken, this.successEvent, langCode, formId);
        }
      })
      .catch(error => {
        if (!this.emailSent) {
          this.emailSent = true;
          let errorMessage = error.stack !== undefined ? error.stack : error.code.stack;
          errorMessage += ' -> ' + navigator.userAgent;
          api.post(
            'cms/send_avail_error',
            [{ url: window.document.location.href, message: 'Error Render Cashier EPG', error: errorMessage }],
            hotel.get('id')
          );
        }
      });
  };

  /**
   *
   * @param inputList {Object}
   * @param hotel {Map}
   * @param reservation {Map}
   * @param hotelCurrencyCode {string}
   * @param showTaxes {boolean}
   * @param countryCode {string}
   * @param langCode {string}
   * @param formId {string}
   * @param setReservationPayed {function}
   * @param showConfirmation {function}
   * @param showErrorNotification {function}
   * @param setStateEPGPrepaymentToken {function}
   * @param checkTpvContainer
   * @param manageLoading {function}
   * @returns {Promise}
   */
  chargePayment = (
    inputList,
    hotel,
    reservation,
    hotelCurrencyCode,
    showTaxes,
    countryCode,
    langCode,
    formId,
    setReservationPayed,
    showConfirmation,
    showErrorNotification,
    setStateEPGPrepaymentToken,
    checkTpvContainer,
    manageLoading
  ) => {
    this.nRetry++;
    return this.sendChargeOperation(
      hotel.get('code'),
      hotel.get('id'),
      reservation.get('tracking_id'),
      reservation.get('pin_code'),
      countryCode,
      hotelCurrencyCode
    )
      .then(responseCharge => {
        if (responseCharge.success) {
          if (responseCharge.redirection_3ds !== false) {
            window.location.replace(responseCharge.redirection_3ds);
            return true;
          } else {
            this.paymentToken = responseCharge.card_number_token;
            setReservationPayed(reservation, showTaxes);
            this.onSubmitPromiseResolve('OK');
            return showConfirmation(reservation, hotel);
          }
        } else {
          this.initialize(
            hotel,
            reservation,
            countryCode,
            langCode,
            formId,
            showErrorNotification,
            setStateEPGPrepaymentToken,
            checkTpvContainer
          );
          manageLoading(false);
          this.onSubmitPromiseReject(Error('success: false'));
          return false;
        }
      })
      .catch(error => {
        this.initialize(
          hotel,
          reservation,
          countryCode,
          langCode,
          formId,
          showErrorNotification,
          setStateEPGPrepaymentToken,
          checkTpvContainer
        );
        const logger = loggerGetter();
        logger.process('stop').clearLog();
        manageLoading(false);
        this.onSubmitPromiseReject(error);
        return false;
      });
  };

  /**
   *
   * @param stateRetriever {function}
   * @param validatePaymentForms {function}
   * @param setStateEPGPrepaymentToken {function}
   * @param trackingId
   * @returns {Function}
   */
  onValidate = (stateRetriever, validatePaymentForms, setStateEPGPrepaymentToken, trackingId) => responseTpv => {
    const { validForm, inputList, manageLoading } = stateRetriever();

    const urlArray = window.location.hash.split('/');
    const trackingURL = urlArray[2];

    if (
      typeof responseTpv !== 'undefined' &&
      typeof responseTpv.prepayToken !== 'undefined' &&
      +trackingId === +trackingURL
    ) {
      this.prepayToken = responseTpv.prepayToken;
      setStateEPGPrepaymentToken(responseTpv.prepayToken);
      validatePaymentForms(validForm, inputList, stateRetriever);
    } else if (trackingId === trackingURL) {
      this.onSubmitPromiseReject(Error('Invalid EPG Response'));
    }
  };

  /**
   *
   * @param hotelCode  {string}
   * @param hotelID {number}
   * @param trackingID  {number}
   * @param country {string}
   * @param currency {string}
   * @returns {Promise}
   */
  sendAuthRequest = (hotelCode, hotelID, trackingID, country, currency) => {
    const domain = process.env.URL_ENVIRONMENT;
    const url = domain + '/api/hotels/' + hotelID + '/cms/epg_auth';
    const data = { hotel: hotelCode, hotel_id: hotelID, tracking_id: trackingID, country: country, currency: currency };
    return this.query(url, 'POST', data, null, true);
  };

  /**
   *
   * @param hotelCode {string}
   * @param hotelID {string}
   * @param trackingID {number}
   * @param pinCode {string}
   * @param country {string}
   * @param currency {string}
   * @returns {Promise}
   */
  sendChargeOperation = (hotelCode, hotelID, trackingID, pinCode, country, currency) => {
    const domain = process.env.URL_ENVIRONMENT;
    const url = domain + '/api/hotels/' + hotelID + '/cms/epg_charge';
    const data = {
      hotel: hotelCode,
      tracking_id: trackingID,
      pin_code: pinCode,
      country: country,
      currency: currency,
      prepay_token: this.prepayToken,
      merchant_transaction_id: hotelID + '-' + trackingID + '-' + this.nRetry,
      location: document.URL
    };

    return this.query(url, 'POST', data);
  };

  /**
   *
   * @param hotel {string}
   * @param hotelID {string}
   * @param trackingID {number}
   * @param pinCode {string}
   * @param currency {string}
   * @returns {*}
   */
  sendRefundOperation = (hotel, hotelID, trackingID, pinCode, currency) => {
    const data = { hotel: hotel, tracking_id: trackingID, pin_code: pinCode, currency: currency };

    const domain = process.env.URL_ENVIRONMENT;
    const url = domain + '/api/hotels/' + hotelID + '/cms/epg_refund';

    return this.query(url, 'POST', data);
  };
}
